import {useQuery} from '@tanstack/react-query'
import {useGoogleMapsApiLoader} from '../index'
import {isServer} from '../../utils/utils'

/**
 * Hook to load Google Maps API on demand
 * @param {import("@tanstack/react-query").UseQueryOptions} [queryOptions] - React Query options
 * @returns {import("@tanstack/react-query").UseQueryResult<google.maps>}
 * @see <a href="https://tanstack.com/query/latest/docs/react/reference/useQuery">TanStack Query `useQuery` reference</a> for more information about the return value.
 */
export const useGoogleMapsApi = (queryOptions) => {
    const getGoogleMapsAPI = useGoogleMapsApiLoader()

    return useQuery({
        queryKey: ['google-maps-api'],
        queryFn: getGoogleMapsAPI,
        staleTime: Infinity,
        cacheTime: Infinity,
        ...queryOptions,
        enabled: !isServer && queryOptions?.enabled !== false
    })
}
